import React,{useState, useEffect} from 'react';
import { Box, Avatar, CircularProgress} from "@mui/material";
import BtnSecondary from "../../../../../../component/SecondaryButton";
import { getOrgDepartments, getOrgEmployees, getOrgGroups } from "../../../../../../services/globalData";
import { useNotify } from "../../../../../../component/NotificationProvider";
import { useLocation } from "react-router-dom";
import TopBar from '../../../../../../component/TopBar';
import { tokens } from '../../../../../../theme';
import { findGroup } from '../../../../../../utils/findGroup';
import { findDepartment } from '../../../../../../utils/findDepartment';
import FormField from '../../../../../../component/Formfield';
import DateField from '../../../../../../component/DateField';
import Pencil from '../../../../../../assets/icons/pencil.svg';
import BtnPrimary from '../../../../../../component/PrimaryButton';
import TypeBtn from '../../../../../../component/AddRemoveButton';
import SortByTable from '../../../../../../component/assign-policy/SortByTable';
import EditPolicyCategory from './EditPolicyCategory';
import ErrorMsg from '../../../../../../component/ErrorMsg';
import SaveDialog from '../../../../../../component/SaveDialog';
import { addDepartmentsToLeavePolicy, addGroupsToLeavePolicy, getAllLeaveType, getLeavePolicyById, removeDepartmentsFromLeavePolicy, removeGroupsFromLeavePolicy, updateLeavePolicy } from '../../../../../../services/leave';


const HeaderSection = () => (
  <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1.25rem' }}>
      <BtnSecondary sx={{ borderRadius: '8px' }} to="/app/leave-policy">
          Back
      </BtnSecondary>
  </Box>
);

const Headings = ({title,onEditClick, onSaveClick, edit, apiCall}) => (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.5rem", paddingBottom: "0.75rem", borderBottom: `1px solid ${tokens.border}` }}>
      <Box sx={{ fontSize: "1rem", fontWeight: 600, color: tokens.text }}>{title}</Box>
      {
        edit?(
          <BtnPrimary sx={{ borderRadius: '8px' }} onClick={onSaveClick}>
            {apiCall?<CircularProgress size={"1rem"}/>:"Save Changes"}
          </BtnPrimary>
        ):<Avatar src={Pencil} sx={{width:"1.5rem",height:"1.5rem",'&:hover': {cursor: "pointer"}}} onClick={onEditClick}/>
      }
    </Box>
)


const LeavePolicyEdit = () => {
        const {state} = useLocation();
        const [loading, setLoading] = useState(true);
        const [apiCall,setApiCall]=useState(false);
        const [isSaveOpen, setIsSaveOpen]=useState(false);
        const [policyData,setPolicyData] = useState({
              code:"",
              name:"",
              startDate:null,
              endDate:null,
              description:"",
              leaveQuantities:[],
              approvers:[],
        });
        const [startDateDialogOpen, setStartDateDialogOpen] = useState(false);
        const [endDateDialogOpen, setEndDateDialogOpen] = useState(false);
        const [validationErrors, setValidationErrors] = useState({
                                                                  code:"",
                                                                  name:"",
                                                                  startDate:"",
                                                                  endDate:"",
                                                                });
        const [error,setError]=useState("");
        const notify = useNotify();
        const [categoryOptions, setCategoryOptions] = useState([]);
        const approverOptions = (getOrgEmployees() || []).map(employee => ({
                    name: employee.fname+" "+employee.lname,
                    value: employee._id
        }));
        const [sortBy,setSortBy] = useState("");
        const [detailsEdit,setDetailsEdit]=useState(false);
        const [categoryEdit,setCategoryEdit]=useState(false);
        const [assignPolicyEdit,setAssignPolicyEdit]=useState(false);
        const [approverEdit,setApproverEdit]=useState(false);
        const [selectedCategoryIndex, setSelectedCategoryIndex] = useState(null); 
        const [selectedList,setSelectedList] = useState({department: [],employeeGroup:[]});
        const [previousList,setPreviousList] = useState({department: [],employeeGroup:[]});
        const [data, setData] = useState();
        const allDepartments = getOrgDepartments();
        const allGroups = getOrgGroups();

        useEffect(()=>{
          setData(sortBy==="Departments"?allDepartments:allGroups);
        },[sortBy])

        useEffect(()=>{
                getCategoryList();
                getPolicyData(state.policyId);
        },[]);
            
        //to get expense category options
        const getCategoryList = async () => {
        try {
                const res = await getAllLeaveType();
                const categories = (res.data || []).map(category => ({ value: category._id, name: category.name}));
                setCategoryOptions(categories);
        } catch (error) {
                notify.error(error?.message || "Failed to load leave types");
        }
        };

        //to get policy data
        const getPolicyData = async (policyId) => {
                setLoading(true);
                try {
                    const res = await getLeavePolicyById(policyId);
                    const data = res.data;
                    if(res.success){
                          setPolicyData(prevState => ({
                            ...prevState,
                            code: data?.code,
                            name: data?.name,
                            startDate: data?.startDate?.split('T')[0],
                            endDate: data?.endDate?.split('T')[0],
                            description: data?.description,
                            approvers: data?.approvers,
                            leaveQuantities: data?.leaveQuantities,
                            groups: data?.groups,
                            departments: data?.departments
                        })); 
                    }
                    if(data?.groups?.length>0){
                       setSortBy("Groups");
                       setSelectedList(prevState => ({...prevState,employeeGroup: data?.groups}));
                       setPreviousList(prevState => ({...prevState,employeeGroup: data?.groups}));
                    }else if(data?.departments?.length>0){
                      setSortBy("Departments");
                      setSelectedList(prevState => ({...prevState,department: data?.departments}));
                      setPreviousList(prevState => ({...prevState,department: data?.departments}));
                    }
                } catch (error) {
                    notify.error(error?.message || "Failed to load policy data");
                } finally {
                    setLoading(false);
                }
        };
          
        //to manage input
        const handleChange = (field, value) => {
                const updatedValue = field === "code" ? value?.toUpperCase() : value;
                setPolicyData(prevState => ({...prevState, [field]: updatedValue}));
                setValidationErrors(prevState => ({...prevState, [field]: ""}));
                setError("");
        };

        //to display selected policy bearer
        const formatPolicyBearer = (linkTo) =>{
          const employeeGroups = linkTo?.employeeGroup?.map(findGroup)?.map(obj => obj?.name).filter(Boolean).join(', ') || '';
          const departments = linkTo?.department?.map(findDepartment)?.map(obj => obj?.name).filter(Boolean).join(', ') || '';
          if(employeeGroups || departments)
              return `${employeeGroups}${employeeGroups && departments ? ', ' : ''}${departments}`;
          else
              return "No Policy Bearer Assigned Yet"
        }

        const handleAddApproval = () =>{
                setPolicyData(prevState => ({
                        ...prevState,
                        approvers: [...prevState.approvers, ""]
                }));
        }
            
        const handleRemoveApprover = (index) => {
                setPolicyData(prevState => {
                    const approverList = [...prevState.approvers];
                    approverList.splice(index, 1);
                    return {
                        ...prevState,
                        approvers: approverList
                    };
                });
        };
        
        const handleApproverChange = (index, value) => {
                setPolicyData(prevState => {
                    const updatedApprover = [...prevState.approvers];
                    updatedApprover[index] = value;
                    return {
                        ...prevState,
                        approvers: updatedApprover
                    };
                });
        };
            
      const handleSaveChanges = async() =>{
        setError("");
        setApiCall(true);
        try {
          const res = await updateLeavePolicy(state.policyId,policyData);
          if (res?.success) {
            notify.success("Leave policy updated");
            setDetailsEdit(false);
            setApproverEdit(false);
            setCategoryEdit(false);
          } else {
            notify.error(res?.message || "Policy update failed");
          }
        } catch (error) {
          notify.error(error?.message || "Something went wrong updating the policy");
        } finally {
          setApiCall(false);
        }
        handlePolicyLinking();
      }

      const handlePolicyLinking = async() =>{
        setError("");
        setApiCall(true);
        try {
          const departmentsToRemove = previousList?.department?.filter(dept => !selectedList?.department?.includes(dept));
          const groupsToRemove = previousList?.employeeGroup?.filter(grp => !selectedList?.employeeGroup?.includes(grp));

          const deptRemoveRes = await removeDepartmentsFromLeavePolicy(state?.policyId, {departments:departmentsToRemove});
          if(!deptRemoveRes?.success){
              setError(deptRemoveRes?.message);
              notify.error(deptRemoveRes?.message || "Could not update departments");
              return;
          }

          const grpRemoveRes = await removeGroupsFromLeavePolicy(state?.policyId, {groups:groupsToRemove});
          if(!grpRemoveRes?.success){
              setError(grpRemoveRes?.message);
              notify.error(grpRemoveRes?.message || "Could not update groups");
              return;
          }

          const departmentsToAdd = selectedList?.department?.filter(dept => !previousList?.department?.includes(dept));
          const groupsToAdd = selectedList?.employeeGroup?.filter(grp => !previousList?.employeeGroup?.includes(grp));

          const deptAddRes = await addDepartmentsToLeavePolicy(state?.policyId, {departments:departmentsToAdd});
          if(!deptAddRes?.success){
              setError(deptAddRes?.message);
              notify.error(deptAddRes?.message || "Could not assign departments");
              return;
          }

          const grpAddRes = await addGroupsToLeavePolicy(state?.policyId, {groups:groupsToAdd});
          if(!grpAddRes?.success){
              setError(grpAddRes?.message);
              notify.error(grpAddRes?.message || "Could not assign groups");
              return;
          }

          setAssignPolicyEdit(false);
        } catch (error) {
          notify.error(error?.message || "Something went wrong updating policy assignment");
        } finally {
          setApiCall(false);
        }
      }

      const handleNextClick = () =>{
        handleSaveChanges();
        setIsSaveOpen(true);
      }

  return (
    loading?(
      <Box sx={{width:"100%",display:"flex", justifyContent:"center", alignItems:"center", height:"100vh"}}>
        <CircularProgress/>
      </Box>
    ):(
    <Box sx={{ width: "100%" }}>
        <TopBar MainHeading={"Leave Policy"} breadcrumbs={[{label:"Leave Policy", href:"/app/leave-policy"},{label:"Edit"}]}/>
        <Box sx={{ background: tokens.surface, border: `1px solid ${tokens.border}`, borderRadius: "12px", p: { xs: "1.25rem", md: "1.75rem" } }}>
        <HeaderSection/>
        <Box sx={{marginBottom: '1.9375rem'}}>
            <Headings 
             title="Policy Details" 
             edit={detailsEdit} 
             onEditClick={()=>setDetailsEdit(true)} 
             onSaveClick={handleSaveChanges}
             apiCall={apiCall}
            />
            <Box sx={{ width: "100%", display: "flex", flexWrap: "wrap", justifyContent: "space-between" }}>
                      <FormField
                          label="Policy Code"
                          type="text"
                          value={policyData.code}
                          validation={validationErrors.code}
                          disabled={!detailsEdit}
                          onChange={(e) => handleChange('code', e.target.value)}
                      />
                      <FormField
                          label="Policy Name"
                          type="text"
                          value={policyData.name}
                          validation={validationErrors.name}
                          disabled={!detailsEdit}
                          onChange={(e) => handleChange('name', e.target.value)}
                      />
                      <FormField
                        label="Description"
                        type="text"
                        value={policyData.description}
                        fullwidth
                        row={2}
                        disabled={!detailsEdit}
                        onChange={(e) => handleChange('description', e.target.value)}
                      />
                      <DateField
                        label="Policy Valid From"
                        value={policyData.startDate}
                        isDialogOpen={startDateDialogOpen}
                        validation={validationErrors.startDate}
                        openDialog={() => setStartDateDialogOpen(true)}
                        closeDialog={() => setStartDateDialogOpen(false)}
                        onSelect={(date) => {
                                  handleChange('startDate', date)
                                  setStartDateDialogOpen(false)
                                  }}
                        disabled={!detailsEdit}
                      />
                      <DateField
                        label="Policy Valid Till"
                        value={policyData.endDate}
                        isDialogOpen={endDateDialogOpen}
                        validation={validationErrors.endDate}
                        openDialog={() => setEndDateDialogOpen(true)}
                        closeDialog={() => setEndDateDialogOpen(false)}
                        onSelect={(date) => {
                                  handleChange('endDate', date)
                                  setEndDateDialogOpen(false)
                                }}
                        disabled={!detailsEdit}
                      />
            </Box>
        </Box>
        <Box sx={{marginBottom: '1.9375rem'}}>
            <Headings 
             title="Add Category" 
             edit={categoryEdit} 
             onEditClick={()=>setCategoryEdit(true)} 
             onSaveClick={handleSaveChanges}
             apiCall={apiCall}
            />
            <EditPolicyCategory
              categoryEdit={categoryEdit}
              policyData={policyData}
              setPolicyData={setPolicyData}
              categoryOptions={categoryOptions}
              setSelectedCategoryIndex={setSelectedCategoryIndex}
            /> 
        </Box>
        <Box sx={{marginBottom: '1.9375rem'}}>
            <Headings 
             title="Assign Policy" 
             edit={assignPolicyEdit} 
             onEditClick={()=>setAssignPolicyEdit(true)} 
             onSaveClick={handlePolicyLinking}
             apiCall={apiCall}
            />
            <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems:"center" }}>
                        <FormField
                            label="Sort By"
                            type="select"
                            options={["Departments","Groups"]}
                            value={sortBy}
                            disabled={!assignPolicyEdit}
                            onChange={(e)=>{setSortBy(e.target.value)}}
                        />
                        <FormField
                            label="Policy Bearers"
                            type="text"
                            value={formatPolicyBearer(selectedList)}
                            disabled={true}
                        />
            </Box>
            <Box sx={{marginBottom: "1rem"}}>
                <ErrorMsg>{error}</ErrorMsg>
            </Box>
            {(sortBy && assignPolicyEdit) && (
              <SortByTable
                sortBy={sortBy}
                data={data}
                selectedList={selectedList}
                setSelectedList={setSelectedList}  
              />
            )}   
        </Box>
        <Box>
            <Headings 
             title="Rules" 
             edit={approverEdit} 
             onEditClick={()=>setApproverEdit(true)} 
             onSaveClick={handleSaveChanges}
             apiCall={apiCall}
            />
            <Box>
            <Box>
            {   policyData?.approvers?.length > 0 ? (
                <Box>
                 <Box sx={{fontSize: "1rem",lineHeight: 1.7, color: tokens.textMuted,marginBottom: "1rem"}}>
                    Approval Chain
                  </Box>
                 {
                  policyData?.approvers?.map((item,index)=>(
                    <Box key={index} 
                         sx={{ width: "100%", 
                               display: "flex",  
                               marginBottom: "1rem", 
                               justifyContent:"space-between",
                               padding: "1.25rem 2rem",
                               borderRadius:"10px",
                               border:`1px solid `
                            }}
                    >
                          <FormField
                              placeholder="Employee Name"
                              type="select"
                              options={approverOptions}
                              value={item}
                              disabled={!approverEdit}
                              onChange={(e) => handleApproverChange(index, e.target.value)}
                          />
                          <TypeBtn type="remove" onClick={()=>handleRemoveApprover(index)} disabled={!approverEdit}>
                                  Remove 
                          </TypeBtn>
                    </Box>
                  ))
                  }
                </Box>
              ): (
                <Box sx={{fontSize:"1rem",lineHeight: 1.7, color: tokens.textMuted, marginBottom: "1rem"}}>
                        No approvers assigned yet
                </Box>
              )
            }
            <Box sx={{display:approverEdit?"flex":"none"}}>
                <TypeBtn onClick={handleAddApproval} type="add">
                    Add Approver
                </TypeBtn>
            </Box>
          </Box>
        </Box>
        </Box>
        <Box sx={{display:"flex", justifyContent:"center", gap: "1rem", marginTop: "2rem"}}>
              <BtnPrimary 
                onClick={handleNextClick} 
                sx={{width:"18.75rem", height:"3.125rem", borderRadius:"10px"}}
                disabled={apiCall}
              >
                  {apiCall?<CircularProgress color='info'/>:"Save Changes"}
              </BtnPrimary> 
        </Box>
        <SaveDialog
            open={isSaveOpen}
            onClose={()=>setIsSaveOpen(false)}
            redirectLink={"/app/leave-policy"}
        />
        </Box>
    </Box>
  ))
}

export default LeavePolicyEdit
        